import { TeaserClient } from "./TeaserClient";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { onLoad } from "@otto-ec/global-resources/dom";
import { Teaser } from "./teaser";

const teaserClient = new TeaserClient();

onLoad.on(() => {
	const teaserContainer = document.getElementById("benefit_teaser");
	if (teaserContainer) {
		new Teaser(teaserClient, eventQBus).init(teaserContainer);
	}
});
